<template>
  <div class="container">

  <div class="unconnected" v-if="!needRefresh">
    <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-alert-circle"></use>
    </svg>
    Offline
  </div>

  <p class="chart-title pmy-0">
    <!-- Container：{{this.datas.ContainerID}} -->
  </p>
  <p class="title">Memory(%)</p>
  <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :animate="false" padding="auto" class="v-chart">
    <v-coord type="polar" :startAngle="-202.5" :endAngle="22.5" :radius="0.75"></v-coord>
    <v-axis
      dataKey="value"
      :zIndex="2"
      :line="null"
      :label="axisLabel"
      :subTickCount="4"
      :subTickLine="axisSubTickLine"
      :tickLine="axisTickLine"
      :grid="null"
    ></v-axis>
    <v-axis dataKey="1" :show="false"></v-axis>
    <v-series
      gemo="point"
      position="value*1"
      shape="pointer"
      color="#8C8C8C"
      :active="false"
    ></v-series>
    <v-guide type="arc" :zIndex="0" :top="false" :start="arcGuideBgStart" :end="arcGuideBgEnd" :vStyle="arcGuideBgStyle"></v-guide>
    <v-guide type="arc" :zIndex="1" :start="arcGuideLowestStart" :end="arcGuideLowestEnd" :vStyle="arcGuideLowestStyle"></v-guide>
    <v-guide type="arc" :zIndex="1" :start="arcGuideLowStart" :end="arcGuideLowEnd" :vStyle="arcGuideLowStyle"></v-guide>
    <v-guide type="arc" :zIndex="1" :start="arcGuideMidStart" :end="arcGuideMidEnd" :vStyle="arcGuideMidStyle"></v-guide>
    <v-guide type="arc" :zIndex="1" :start="arcGuideHighStart" :end="arcGuideHighEnd" :vStyle="arcGuideHighStyle"></v-guide>
    <v-guide
      type="html"
      :position="htmlGuidePosition"
      :html="htmlGuideHtml"
    ></v-guide>
  </v-chart>

  </div>
</template>

<script>
import { registerShape } from 'viser-vue';
import { ERR_DATA } from './config'
const TEST_DATA = process.env.NODE_ENV !== 'production' ? false : false // eslint-disable-line

registerShape('point', 'pointer', {
  draw(cfg, container) {
    let point = cfg.points[0]; // 获取第一个标记点
    point = this.parsePoint(point);
    const center = this.parsePoint({ // 获取极坐标系下画布中心点
      x: 0,
      y: 0
    });
    // 绘制指针
    container.addShape('line', {
      attrs: {
        x1: center.x,
        y1: center.y,
        x2: point.x,
        y2: point.y + 15,
        stroke: cfg.color,
        lineWidth: 5,
        lineCap: 'round'
      }
    });
    return container.addShape('circle', {
      attrs: {
        x: center.x,
        y: center.y,
        r: 9.75,
        stroke: cfg.color,
        lineWidth: 4.5,
        fill: '#fff'
      }
    });
  }
});

const scale = [{
  dataKey: 'value',
  min: 0,
  max: 9,
  tickInterval: 1,
  nice: false
}];

const color = ['#4CAF50', '#2196F3', '#FF9800', '#F44336'];

export default {
  props: {
    datas: {
      type: Object,
      default: () => ({})
    },
    onAlarm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    needRefresh() {
      return this.datas.Status != 0
    }
  },
  watch: {
    datas(newVal, oldVal){
      if (!oldVal) {
        this.setData()
      } else {
        if (newVal.Memory != oldVal.Memory) {
          this.setData()
        }
      }
    }
  },
  methods: {
    setData() {
      // if (this.timer) {
      //   clearTimeout(this.timer);
      // }

      const nextVal = TEST_DATA === false ? ((this.datas.Memory == ERR_DATA ? 0 : this.datas.Memory) / 10) : TEST_DATA;
      //console.log(nextVal)
      this.$data.data[0].value = nextVal;
      this.$data.arcGuideLowestEnd[0] = Math.max(0, Math.min(2, nextVal));
      this.$data.arcGuideLowEnd[0] = Math.max(2, Math.min(5, nextVal));
      this.$data.arcGuideMidEnd[0] = Math.max(5, Math.min(7, nextVal));
      this.$data.arcGuideHighEnd[0] = Math.max(7, Math.min(9, nextVal));
      this.$data.htmlGuideHtml = `
        <div style="width: 300px;text-align: center;">
          <p style="font-size: 24px;color: #545454;margin: 0;">${Math.ceil(nextVal * 10)}%</p>
        </div>
      `;

      // const delta = Math.random();
      // const prevVal = this.$data.data[0].value;
      // if (this.$data.trend === 'up') {
      //   const nextVal = prevVal + delta;
      //   if (nextVal > 9) {
      //     this.$data.trend = 'down';
      //   } else {
      //     this.$data.data[0].value = nextVal;
      //     this.$data.arcGuideLowEnd[0] = Math.max(0, Math.min(3, nextVal));
      //     this.$data.arcGuideMidEnd[0] = Math.max(3, Math.min(6, nextVal));
      //     this.$data.arcGuideHighEnd[0] = Math.max(6, Math.min(9, nextVal));
      //     this.$data.htmlGuideHtml = `
      //       <div style="width: 300px;text-align: center;">
      //         <p style="font-size: 24px;color: #545454;margin: 0;">${Math.ceil(nextVal * 10)}%</p>
      //       </div>
      //     `;
      //   }
      // } else {
      //   const nextVal = prevVal - delta;
      //   if (nextVal < 0) {
      //     this.$data.trend = 'up';
      //   } else {
      //     this.$data.data[0].value = nextVal;
      //     this.$data.arcGuideLowEnd[0] = Math.max(0, Math.min(3, nextVal));
      //     this.$data.arcGuideMidEnd[0] = Math.max(3, Math.min(6, nextVal));
      //     this.$data.arcGuideHighEnd[0] = Math.max(6, Math.min(9, nextVal));
      //     this.$data.htmlGuideHtml = `
      //       <div style="width: 300px;text-align: center;">
      //         <p style="font-size: 24px;color: #545454;margin: 0;">${Math.ceil(nextVal * 10)}%</p>
      //       </div>
      //     `;
      //   }
      // }

      // this.timer = setTimeout(this.setData, 3000);
    }
  },
  mounted() {
    // this.timer = setTimeout(this.setData, 0);
  },
  beforeDestroy() {
    // if (this.timer) {
    //   clearTimeout(this.timer);
    // }
  },
  data() {
    const data = [
      {
        value: TEST_DATA === false ? ((this.datas.Memory == ERR_DATA ? 0 : this.datas.Memory) / 10) : TEST_DATA }
    ];

    return {
      height: 200,
      data: data,
      scale: scale,

      axisLabel: {
        offset: -16,
        textStyle: {
          fontSize: 18,
          textAlign: 'center',
          textBaseline: 'middle'
        }
      },
      axisSubTickLine: {
        length: -8,
        stroke: '#fff',
        strokeOpacity: 1,
      },
      axisTickLine: {
        length: -17,
        stroke: '#fff',
        strokeOpacity: 1,
      },

      arcGuideBgStart: [0, 0.945],
      arcGuideBgEnd: [9, 0.945],
      arcGuideBgStyle: {
        stroke: '#CBCBCB',
        lineWidth: 18,
      },
      arcGuideLowestStart: [0, 0.945],
      arcGuideLowestEnd: [Math.max(0, Math.min(2, data[0].value)), 0.945],
      arcGuideLowestStyle: {
        stroke: color[0],
        lineWidth: 18,
      },
      arcGuideLowStart: [2, 0.945],
      arcGuideLowEnd: [Math.max(2, Math.min(5, data[0].value)), 0.945],
      arcGuideLowStyle: {
        stroke: color[1],
        lineWidth: 18,
      },
      arcGuideMidStart: [5, 0.945],
      arcGuideMidEnd: [Math.max(5, Math.min(7, data[0].value)), 0.945],
      arcGuideMidStyle: {
        stroke: color[2],
        lineWidth: 18,
      },
      arcGuideHighStart: [7, 0.945],
      arcGuideHighEnd: [Math.max(7, Math.min(9, data[0].value)), 0.945],
      arcGuideHighStyle: {
        stroke: color[3],
        lineWidth: 18,
      },

      htmlGuidePosition: ['50%', '95%'],
      htmlGuideHtml: `
        <div style="width: 300px;text-align: center;">
          <p style="font-size: 24px;color: #545454;margin: 0;">${(data[0].value) * 10}%</p>
        </div>
      `,
    };
  },
  created() {
    this.marker_alarm = require('../../../assets/icon/alarm.gif')
  }
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  .title {
    // position: absolute;
    top: -15px;
    text-align: center;
    width: 100%;
    margin-bottom: -20px;
  }
  .i-charts-alarm {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
  .unconnected {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(96,125,139,.4);
    text-align: center;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #FFF;
  }
  .v-chart {
    text-align: center;
    & /deep/ {
      & > div{
        display: inline-block;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/home/charts/chart-memory.vue